import { Helmet } from 'react-helmet-async'
import useSiteSettings from '../hooks/useSiteSettings'

const SEO = ({ title, description, keywords, image, url }) => {
  const { siteName, siteTagline } = useSiteSettings()
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Quality Healthcare`
  const fullDescription = description || siteTagline || 'Quality healthcare with compassion and convenience for the whole family.'
  const fullImage = image || 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=1200&q=80'

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="og:title" content={fullTitle} />
      <meta name="og:description" content={fullDescription} />
      <meta name="og:image" content={fullImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />
      {url && <meta name="og:url" content={url} />}
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href={url || 'https://harmonymedical.com'} />
    </Helmet>
  )
}

export default SEO
